import React, { useContext } from 'react';
import { useSession } from '@/auth/index';
import { AppConstants } from '@/context/AppConstants';
import { HeaderSearch } from './HeaderSearch/HeaderSearch';
import { NavigationHeader } from './HeaderSearch/NavigationHeader';
import { JoinButton } from './JoinButton/JoinButton';
import { ReactivateHeader } from './ReactivateHeader/ReactivateHeader';
import { SearchTabData } from '../../SearchFormsContainer/interfaces';

interface HeaderContentsProps {
  handleLogout: () => void;
  setSelectedTab: (tab: SearchTabData) => void;
  selectedTab: SearchTabData | null;
  toggleSearchFormsIsMounted: () => void;
  enableSmartSearch: boolean;
  shouldHideSearchForm?: boolean;
  isInternationalVinTest?: boolean;
  isInInternationalLanguageTest?: boolean;
}

export function HeaderContents({
  handleLogout,
  setSelectedTab,
  selectedTab,
  toggleSearchFormsIsMounted,
  enableSmartSearch,
  shouldHideSearchForm,
  isInternationalVinTest,
  isInInternationalLanguageTest,
}: HeaderContentsProps) {
  const {
    session: { isAuthenticated },
  } = useSession();
  const {
    featureFlags: { navigationHeaderEnabled },
  } = useContext(AppConstants);

  const isInReactivationRoute =
    window.location.pathname.includes('/reactivation');

  if (!isAuthenticated) {
    return <JoinButton />;
  }
  if (isInReactivationRoute) {
    return <ReactivateHeader handleLogout={handleLogout} />;
  }
  if (navigationHeaderEnabled) {
    return (
      <NavigationHeader
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
      />
    );
  }

  return (
    <HeaderSearch
      setSelectedTab={setSelectedTab}
      selectedTab={selectedTab}
      toggleIsMounted={toggleSearchFormsIsMounted}
      enableSmartSearch={enableSmartSearch}
      shouldHideSearchForm={shouldHideSearchForm}
      isInternationalVinTest={isInternationalVinTest}
      isInInternationalLanguageTest={isInInternationalLanguageTest}
    />
  );
}
